import React from 'react';
import { connect } from 'react-redux';
import ShowtimesBlock from './ShowtimesBlock';
import { ShowtimesBlockProps } from './ShowtimesBlock';
import Button from '../../Button';
import { areaSelectorSelectArea } from '../../../actions/creators/ui';
import { getAreasById, getStatesById } from '../../../reducers';

interface Props extends ShowtimesBlockProps {
    area: { type: 'state' | 'area', id: number, name: string } | undefined;
    areaEntity: { id: number, name: string, state_id: number } | null;
    stateEntity: { id: number, name: string } | null;
    onAreaSelect: (type: string, id: number) => void;
    onAreaSelectorOpen: () => void;
}

const AreaCinemasShowtimesBlock = (props: Props) => {
    let subtitle = '';
    if (props.area) {
        subtitle = 'Mostrando cines en ';
        
        if ('area' === props.area.type && props.stateEntity) {
            subtitle += props.stateEntity.name + ' - ';
        }

        subtitle += props.area.name;
    }
    
    return <ShowtimesBlock
        {...props}
        title="Todos los cines"
        subtitle={<>
            {subtitle}
            <br/>
            <a href="#" onClick={e => { e.preventDefault(); props.onAreaSelectorOpen(); }}>Cambiar a otra zona</a>
        </>}
        emptyMessage="No hay horarios disponibles para esta película con las opciones seleccionadas"
        Content={Content}
        cinemaFiltersEnabled={true}
    />;
};

const Content = (props: Props) => {
    const selectState = () => {
        props.areaEntity && props.onAreaSelect('state', props.areaEntity.state_id);
    };

    if (!props.area) {
        return <div className="my-3 text-center">
            <p>Por favor <strong>selecciona una zona</strong> para ver los horarios.</p>
            <Button block onClick={props.onAreaSelectorOpen}>Seleccionar zona</Button>
        </div>;
    }

    if (props.data && (!props.data.cinemas || !props.data.cinemas.length) && !props.loading) {
        return <div className="my-3 text-center">
            <p style={{ fontSize: '2em' }}>
                💔
            </p>
            <p className="mt-4 mb-5">
                Esta película no está disponible en {props.area.name}.
                <br/>
                <strong>Elige {'area' === props.area.type ? 'otra zona' : 'otro estado'}</strong> para consultar la disponibilidad.
            </p>
            {!!props.area && 'area' === props.area.type && !!props.areaEntity
                ? <>
                    {!!props.stateEntity && <Button block primary onClick={selectState} className='mb-3'>Buscar en todo {props.stateEntity.name}</Button>}
                    <Button block onClick={props.onAreaSelectorOpen} className='mb-3'>Cambiar a otra zona</Button>
                </>
                : <Button block primary onClick={props.onAreaSelectorOpen}>Cambiar a otro estado</Button>}
        </div>;
    }

    return null;
};

const mapStateToProps = (state, ownProps) => {
    const areasById = getAreasById(state);
    const areaEntity = ownProps.area ? areasById[ownProps.area.id] : null;
    const statesById = getStatesById(state);
    const stateId = ownProps.area && areaEntity
        ? 'area' === ownProps.area.type ? areaEntity.state_id : ownProps.area.id
        : null;
    const stateEntity = areaEntity ? statesById[stateId] : null;

    return {
        areaEntity,
        stateEntity,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onAreaSelect: (type: string, id: number) => dispatch(areaSelectorSelectArea(type, id, { context: 'global' })),
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AreaCinemasShowtimesBlock);